var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentsName[_vm.info.chain_type],{tag:"component",attrs:{"info":_vm.info,"hash":_vm.hash,"isMB":_vm.isMB}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }